import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ActiveTasksContext from '../../providers/ActiveTasksContext';
import language from '../../variables/language';
import IconDone from '../icons/IconDone';
import IconWrong from '../icons/IconWrong';
import IconCloseX from '../icons/IconCloseX';

// Transient completion pop-ups, separate from the persistent tray
// (ActiveTasksTray) - the tray always shows "what's running/just
// finished", these appear once at the exact moment a task settles and
// fade themselves out, so a teacher watching the screen gets an
// unmissable signal without the tray alone (easy to miss if attention is
// elsewhere on the page).
export default function TaskToastStack() {
   const { toasts, dismissToast } = useContext(ActiveTasksContext);
   const navigate = useNavigate();
   const lang = language[language.lang];
   const t = lang.activeTasks;

   if (toasts.length === 0) {
      return '';
   }

   const handleClick = (toast) => {
      if (toast.taskType === 'quiz-generation' && toast.status === 'success' && toast.conversationId) {
         navigate('/conversations-creator-canvas/' + toast.conversationId);
      }
      dismissToast(toast.id);
   };

   return (
      <div className='task-toast-stack'>
         {toasts.map((toast) => (
            <div key={toast.id} className={'task-toast task-toast-' + toast.status} onClick={() => handleClick(toast)}>
               <span className='task-toast-icon'>
                  {toast.status === 'success'
                     ? <IconDone fillColor='icon-green' style={{width:18,height:18,margin:0}} />
                     : <IconWrong fillColor='icon-red' style={{width:18,height:18,margin:0}} />}
               </span>
               <span className='task-toast-body'>
                  <span className='task-toast-title'>{toast.status === 'success' ? t.toastSuccessTitle : t.toastErrorTitle}</span>
                  <span className='task-toast-message'>
                     {toast.status === 'success' ? t.quizGenerationSuccess + ' ' + toast.studentLabel : t.quizGenerationError + ' ' + toast.studentLabel}
                  </span>
               </span>
               <span className='task-toast-dismiss' onClick={(e) => { e.stopPropagation(); dismissToast(toast.id); }}>
                  <IconCloseX />
               </span>
            </div>
         ))}
      </div>
   );
}
